module.exports = __webpack_public_path__ + "img/DeathKnight.f41bca02.jpg";